module.exports = __webpack_public_path__ + "media/img/pages/companies/e+h-3133d9a571359d9e5a21d7ac9c2194e0.png";